import Panel from '~/components/Panel';
import { formatCurrency } from '~/common/form/Inputs';
import { FaExclamationTriangle, FaSync } from 'react-icons/fa';

interface Props {
    amount: number;
    availableFunds: number;
    rawAvailableFunds?: number;
    approvedPendingTotal?: number;
    unapprovedTotal?: number;
    hasInsufficientFunds?: boolean;
    onRefreshFunds?: () => void;
    isRefreshing?: boolean;
}

const RequestAmountBlock: React.FC<Props> = ({
    amount,
    availableFunds,
    rawAvailableFunds,
    approvedPendingTotal,
    unapprovedTotal,
    hasInsufficientFunds = false,
    onRefreshFunds,
    isRefreshing = false,
}) => {
    const panelClasses = hasInsufficientFunds
        ? 'border-[#fdeaeb] bg-[#fdeaeb] flex-1'
        : 'border-[#f8f9eb] bg-[#f8f9eb] flex-1';

    return (
        <>
            <Panel addClasses={panelClasses}>
                <h2 className='text-[16px]/[24px] font-medium uppercase text-[#131212]'>
                    Request Amount
                </h2>
                <div className='text-[38px]/[44px] font-bold text-[#131212]'>
                    {formatCurrency(amount)}
                </div>
                <div className='flex items-center justify-between text-[16px]/[24px] text-[#686868]'>
                    <div className='flex items-center gap-2'>
                        {hasInsufficientFunds && (
                            <FaExclamationTriangle
                                className='text-[#F02D3A]'
                                size={16}
                            />
                        )}
                        <span
                            className={
                                availableFunds < 0 ? 'text-[#F02D3A]' : ''
                            }
                        >
                            {`${formatCurrency(availableFunds)}  (Available)`}
                        </span>
                    </div>
                    {onRefreshFunds && (
                        <button
                            onClick={onRefreshFunds}
                            disabled={isRefreshing}
                            className={`hover:bg-gray-200 ml-2 rounded-full p-1 transition-colors ${
                                isRefreshing
                                    ? 'cursor-not-allowed opacity-50'
                                    : 'cursor-pointer'
                            }`}
                            title='Refresh funds'
                        >
                            <FaSync
                                className={`text-[#00AEB3] ${
                                    isRefreshing ? 'animate-spin' : ''
                                }`}
                                size={14}
                            />
                        </button>
                    )}
                </div>
                {(rawAvailableFunds !== undefined ||
                    approvedPendingTotal !== undefined ||
                    unapprovedTotal !== undefined) && (
                    <div className='mt-2 flex flex-col gap-0.5 text-[13px]/[20px] text-[#686868]'>
                        {rawAvailableFunds !== undefined && (
                            <div>
                                Current: {formatCurrency(rawAvailableFunds)}
                            </div>
                        )}
                        {approvedPendingTotal !== undefined && (
                            <div>
                                Approved: {formatCurrency(approvedPendingTotal)}
                            </div>
                        )}
                        {unapprovedTotal !== undefined && (
                            <div>
                                Unapproved: {formatCurrency(unapprovedTotal)}
                            </div>
                        )}
                    </div>
                )}
            </Panel>
        </>
    );
};

export default RequestAmountBlock;
